import { FinancialRounding } from 'partner360/models/financialRounding'

export const getAutoRounding = (value: number): FinancialRounding => {
  const absValue = Math.abs(value)

  if (absValue >= 1_000_000) {
    return FinancialRounding.M
  }

  if (absValue >= 1_000) {
    return FinancialRounding.K
  }

  return FinancialRounding.AsIs
}
